export default function isSellable(product = {}) {
  return (
    product.is_master === false ||
    product.variants === undefined ||
    product.variants.length == 0
  )
}
